  export const s3Config = {
    bucketName: "bayin",
    dirName: "category",
    region: "us-east-1",
    //  accessKeyId: "AKIASEVRSUZK36B4AK6A",
    //  secretAccessKey: "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",
    
    accessKeyId: 'AKIASEVRSUZK6Y4QNMFD',
     secretAccessKey: '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',
  };

  

    window.Buffer = window.Buffer || require("buffer").Buffer;